import index from './index.vue'
export default index


// WEBPACK FOOTER //
// ./src/components/global/heads/index.js